import { ActivitiesForm } from '@gtpl/pages/hrms/hrms-components/activities-form';
import { ActivitiesGrid } from '@gtpl/pages/hrms/hrms-components/activities-grid';
import { ApplyForLeavesForm, ApplyForLeavesManualForm, ApplyForOdCoForm } from '@gtpl/pages/hrms/hrms-components/apply-for-leaves-form';
import { ApplyForLeavesGrid, ApplyForOdCoGrid } from '@gtpl/pages/hrms/hrms-components/apply-for-leaves-grid';
import { AttendanceAdjustment, AttendanceAdjustmentApproval, CreateAttendanceLogs } from '@gtpl/pages/hrms/hrms-components/attendance-adjustment';
import { DesignationActionForm } from '@gtpl/pages/hrms/hrms-components/designation-action-form';
import { DesignationActionGrid } from '@gtpl/pages/hrms/hrms-components/designation-action-grid';
import { EmployeeLeavesGrid } from '@gtpl/pages/hrms/hrms-components/employee-leaves-grid';
import { EmployeesShiftMapping } from '@gtpl/pages/hrms/hrms-components/employee-shift-mapping';
import { ExitActionForm } from '@gtpl/pages/hrms/hrms-components/exit-action-form';
import { ExitActionGrid } from '@gtpl/pages/hrms/hrms-components/exit-action-grid';
import { ExpensesForm } from '@gtpl/pages/hrms/hrms-components/expenses';
import { ExpensesGrid } from '@gtpl/pages/hrms/hrms-components/expenses-grid';
import { ContractorForm } from '@gtpl/pages/hrms/hrms-components/human-resource-agent-form';
import { ContractorGrid } from '@gtpl/pages/hrms/hrms-components/human-resource-agent-grid';
import { InterviewGrid } from '@gtpl/pages/hrms/hrms-components/interview-grid';
import { JobNotificationsForm } from '@gtpl/pages/hrms/hrms-components/job-notifications-form';
import { JobNotificationsGrid } from '@gtpl/pages/hrms/hrms-components/job-notifications-grid';
import { HolidayCalander, LeaveApprovalGrid } from '@gtpl/pages/hrms/hrms-components/leave-approval-grid';
import { MiscellaneousLogs } from '@gtpl/pages/hrms/hrms-components/miscellaneous-logs';
import { NotificationsForm } from '@gtpl/pages/hrms/hrms-components/notifications-form';
import { NotificationsGrid } from '@gtpl/pages/hrms/hrms-components/notifications-grid';
import { OTApply, OverTimeApproval } from '@gtpl/pages/hrms/hrms-components/ot-apply';
import { OverTimeCategory } from '@gtpl/pages/hrms/hrms-components/over-time-category';
import { OverTimeCategoryGrid } from '@gtpl/pages/hrms/hrms-components/over-time-category-grid';
import { ProfilesForm } from '@gtpl/pages/hrms/hrms-components/profiles-form';
import { ProfilesGrid } from '@gtpl/pages/hrms/hrms-components/profiles-grid';
import { RecruitmentGrid } from '@gtpl/pages/hrms/hrms-components/recruitment-mode';
import { RecruitmentForm } from '@gtpl/pages/hrms/hrms-components/recruitment-mode-form';
import { InterviewForm } from '@gtpl/pages/hrms/hrms-components/schedule-interview-form';
import { Attandance, LeaveBalance, NMenu, otDetails, SelfServicePortal } from '@gtpl/pages/hrms/hrms-components/self-service-portal';
import { Suggestion } from '@gtpl/pages/hrms/hrms-components/suggestion';
import { SuggestionGrid } from '@gtpl/pages/hrms/hrms-components/suggestion-grid';
import { TeamCalender } from '@gtpl/pages/hrms/hrms-components/team-calender-form';
import { TeamCalenderGrid } from '@gtpl/pages/hrms/hrms-components/team-calender-grid';
import { TransferActionForm } from '@gtpl/pages/hrms/hrms-components/transfer-action-form';
import { TransferActionGrid } from '@gtpl/pages/hrms/hrms-components/transfer-action-grid';
import { WorkCalender } from '@gtpl/pages/hrms/hrms-components/work-calender-form';
import { WorkCalenderGrid } from '@gtpl/pages/hrms/hrms-components/work-calender-grid';
import { HrmsEmployeeDetailsForm } from '@gtpl/pages/master/master-components/hrms-employee-details-form';
import { HrmsEmployeeDetailsGrid } from '@gtpl/pages/master/master-components/hrms-employee-details-grid';
import { PayrollGeneration } from '../../../../../libs/pages/payroll/generation/src/lib/pages-payroll-generation';
import { generatedPayGrid } from '../../../../../libs/pages/payroll/generation/src/lib/payroll-generated-view'
import React from 'react';
import { Route } from 'react-router-dom';
import{EmployeeWeekOffUploads} from '../../../../../libs/pages/hrms/hrms-components/employee-week-off-uploads/src/lib/employee-week-off-uploads'
import{EmployeeWeekOffView} from '../../../../../libs/pages/hrms/hrms-components/employee-week-off-uploads/src/lib/employee-week-off-view'
import {empWorkingHrs} from '../../../../../libs/pages/hrms/hrms-components/emp-working-hrs/src/lib/pages-hrms-hrms-components-emp-working-hrs'
import {EmployeePayable} from '../../../../../libs/pages/payroll/allowances/src/lib/pages-payroll-allowances'
import {EmployeePayrollComponent} from '../../../../../libs/pages/payroll/allowances/src/lib/employee-payroll-component'
import {DeductionUpload} from '../../../../../libs/pages/payroll/deductions/src/lib/pages-payroll-deductions'
import {EmployeeDeductionsView} from '../../../../../libs/pages/payroll/deductions/src/lib/deductions-view'
import {PayslipGeneration} from '../../../../../libs/pages/payroll/allowances/src/lib/normal-payslip-generation'
import {EarningsUpload} from '../../../../../libs/pages/payroll/deductions/src/lib/earnings'
import {EarningsView} from '../../../../../libs/pages/payroll/deductions/src/lib/earnings-view'
import {TdsUpload} from '../../../../../libs/pages/payroll/deductions/src/lib/tds-upload'
import {TdsView} from '../../../../../libs/pages/payroll/deductions/src/lib/tds-view'
import {PayslipMail} from '../../../../../libs/pages/payroll/allowances/src/lib/normal-payslip-generation copy'
import AttendanceTabs from 'libs/pages/hrms/hrms-components/attendance-adjustment/src/lib/attendance-main';




export const HrmsRoute = () => {
    return (
        <>
            <Route exact path="/profiles-form" component={ProfilesForm} />
            <Route exact path="/profiles-view" component={ProfilesGrid} />

            <Route exact path="/notifications-form" component={NotificationsForm} />
            <Route exact path="/notifications-view" component={NotificationsGrid} />

            <Route exact path="/activities-form" component={ActivitiesForm} />
            <Route exact path="/activities-view" component={ActivitiesGrid} />
            <Route exact path="/apply-for-leaves" component={ApplyForLeavesForm} />
            <Route exact path="/apply-for-leaves-grid" component={ApplyForLeavesGrid} />
            <Route exact path="/employee-leaves-grid" component={EmployeeLeavesGrid} />
            <Route exact path="/leave-approval" component={LeaveApprovalGrid} />
            <Route exact path="/holiday-calander" component={HolidayCalander} />
            <Route exact path="/job-notifications-view" component={JobNotificationsGrid} />
            <Route exact path="/job-notifications-form" component={JobNotificationsForm} />
            <Route exact path="/interview-view" component={InterviewGrid} />
            <Route exact path="/interview-form" component={InterviewForm} />
            <Route exact path="/contractor-view" component={ContractorGrid} />
            <Route exact path="/contract-form" component={ContractorForm} />
            <Route exact path="/HRMS-employee_details-view" component={HrmsEmployeeDetailsGrid} />
            <Route exact path="/HRMS-employee_details-form" render={props => <HrmsEmployeeDetailsForm hrmsData={undefined}
                isUpdate={false}
                closeForm={() => { }}
                updateDetails={(undefined) => { }}
            />} />
            <Route exact path="/teamcalender-grid" component={TeamCalenderGrid} />
            <Route exact path="/employee-shift-mapping" component={EmployeesShiftMapping} />
            <Route exact path="/teamcalender" component={TeamCalender} />
            <Route exact path="/workcalender-grid" component={WorkCalenderGrid} />
            <Route exact path="/workcalender" component={WorkCalender} />
            <Route exact path="/create-attn-logs" component={CreateAttendanceLogs} />
            <Route exact path="/miscellaneous-logs" component={MiscellaneousLogs} />
            <Route exact path="/attendance-adjustment" component={AttendanceAdjustment} />
            <Route exact path="/attendance-main" component={AttendanceTabs} />
            <Route exact path="/attendance-adjustment-approval" component={AttendanceAdjustmentApproval} />
            <Route exact path="/designation-action-form" component={DesignationActionForm} />
            <Route exact path="/designationaction-view" component={DesignationActionGrid} />
            <Route exact path="/exit-action-view" component={ExitActionGrid} />
            <Route exact path="/exit-action-form" render={props => <ExitActionForm exitActionData={undefined}
                isUpdate={false}
                closeForm={() => { }}
                updateExitAction={(undefined) => { }}
            />} />
            <Route exact path="/transfer-action-view" component={TransferActionGrid} />
            <Route exact path="/transfer-action-form" component={TransferActionForm} />
            <Route exact path="/expenses-form" component={ExpensesForm} />
            <Route exact path="/expenses-view" component={ExpensesGrid} />
            <Route exact path='/suggestion-view' component={SuggestionGrid} />
            <Route exact path="/suggestion" component={Suggestion} />
            <Route exact path="/self-service-portal" component={SelfServicePortal} />
            <Route exact path="/menu" component={NMenu} />
            <Route exact path="/leave-balance-sheet" component={LeaveBalance} />
            <Route exact path="/attandance" component={Attandance} />
            <Route exact path="/ot-details" component={otDetails} />
            <Route exact path="/ot-apply" component={OTApply} />
            <Route exact path="/ot-approval" component={OverTimeApproval} />
            <Route exact path="/employee-week-off-uploads" component={EmployeeWeekOffUploads} />
            <Route exact path="/employee-week-off-view" component={EmployeeWeekOffView} />
            <Route exact path="/employee-working-hrs" component={empWorkingHrs} />
            <Route exact path="/apply-manual-leaves" component={ApplyForLeavesManualForm} />
            <Route exact path="/apply-for-od-co" component={ApplyForOdCoForm} />
            <Route exact path="/apply-for-od-co-grid" component={ApplyForOdCoGrid} />
            <Route exact path="/payroll-generation" component={PayrollGeneration} />
            <Route exact path="/payroll-process" component={EmployeePayable} />
            <Route path="/employee-payroll-component" component={EmployeePayrollComponent} />
            <Route path="/deduction-excel-upload" component={DeductionUpload} />
            <Route path ='/deductions-view' component={EmployeeDeductionsView}/>
            <Route path ='/payslip-genaration' component={PayslipGeneration}/>
            <Route exact path="/generation-view" component={generatedPayGrid} />
            <Route path ='/earnings-excel-upload' component={EarningsUpload}/>
            <Route exact path="/earnings-view" component={EarningsView} />
            <Route exact path="/tds-upload" component={TdsUpload} />
            <Route exact path="/tds-view" component={TdsView} />
            <Route exact path="/payslip-print/:employeeType/:yearMonth/:year/:employeeId"  component={PayslipMail} />


        </>
    );
};
